<template>
<div>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>Send Product Brochure</v-card-title>
        <v-card-text>
          <template v-if="!saving">
            <v-row>
              <v-col>
                <v-select :items="['Web', 'Telco', 'VOIP']" label="Brochure Type" v-model="product_kind" required outlined hide-details dense></v-select>
              </v-col>
            </v-row>
          </template>
          <Loader v-else />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="send">Send</v-btn>
          <v-btn color="primary" outlined small @click="close">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import Loader from "./Loader";
import { mapActions } from "vuex";

export default {
  data: () => ({
    product_kind: "",
    snackbar: false,
    snackbarText: "",
    dialog: false,
    saving: false,
  }),
  props: {
    open: Boolean,
    close: Function,
    account: Number
  },
  components: {
    Loader
  },
  watch: {
    dialog(val) {
      !val && this.close();
    },
    open(val) {
      this.dialog = val;
    }
  },
  methods: {
    ...mapActions("accounts", ["sendBrochure"]),
    ...mapActions("alerts", ["setAlert"]),
    async send() {
      this.saving = true;
      
      try {
        await this.sendBrochure({id:this.account, product_kind:this.product_kind.toLowerCase()});
      } catch(error) {
          return error;
      } finally {
          this.clearData();
          this.close();
      }
    },
    clearData() {
      this.product_kind = "";
      this.saving = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-text-field__prefix {
  color: grey !important;
}
.grid-list-md {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
